import { defAction } from "../../../../helpers/defaultAction"
import { reMeasurementUnitConstants } from "./constants"
import api from './api'

export const reMeasurementUnitActions = {
	getPaged,
	getPagedAll,
	getList,
	create,
	remove,
	update,
	restore,
	clear
}

function getPaged(values){
	const dispatchObj = {
		constants : reMeasurementUnitConstants.GetPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPagedAll(values){
	const dispatchObj = {
		constants : reMeasurementUnitConstants.GetPagedAll,
		service   : {
			func   : api.getPagedAll,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getList(values){
	const dispatchObj = {
		constants : reMeasurementUnitConstants.GetList,
		service   : {
			func   : api.getList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function create(values){
	const dispatchObj = {
		constants : reMeasurementUnitConstants.Create,
		service   : {
			func   : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function remove(values){
	const dispatchObj = {
		constants : reMeasurementUnitConstants.Delete,
		service   : {
			func   : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restore(values){
	const dispatchObj = {
		constants : reMeasurementUnitConstants.Restore,
		service   : {
			func   : api.restore,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function update(values){
	const dispatchObj = {
		constants : reMeasurementUnitConstants.Update,
		service   : {
			func   : api.update,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: reMeasurementUnitConstants.CLEAR
	})
}